import { render, staticRenderFns } from "./RadioVirtualAccountSingle.vue?vue&type=template&id=6bb41f82&lang=pug"
import script from "./RadioVirtualAccountSingle.vue?vue&type=script&lang=js"
export * from "./RadioVirtualAccountSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports